import { motion } from "framer-motion";
import { Confetti, HandHeart, CurrencyGbp } from "@phosphor-icons/react";

const pillars = [
  {
    icon: Confetti,
    title: "Fun & Engaging",
    description:
      "Short-term competition fundraisers that get your members excited and involved.",
  },
  {
    icon: HandHeart,
    title: "Zero Hassle",
    description:
      "We handle everything. Send us your club logo and colours, we do the rest. Your branded fundraiser is live within 24 hours.",
  },
  {
    icon: CurrencyGbp,
    title: "You Keep Everything",
    description:
      "One flat fee to set up. No subscriptions, no commissions. 100% of your members' entry fees go straight to your club's bank account.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.5 },
  }),
};

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      data-testid="what-we-do-section"
      className="py-10 lg:py-14 px-6 bg-[#F8FAFA] border-t border-[#1D3557]/5"
    >
      <div className="max-w-6xl mx-auto">
        <p className="font-body text-xs font-bold uppercase tracking-[0.2em] text-[#E63946] mb-4">
          What We Do
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight leading-none text-[#1D3557] mb-6 lg:mb-8">
          High Impact Fundraisers.<br />No Effort From You.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
          {pillars.map((pillar, i) => (
            <motion.div
              key={pillar.title}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-30px" }}
              variants={fadeUp}
              className="bg-white border border-[#1D3557]/5 p-6 lg:p-8"
              data-testid={`pillar-${pillar.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-heading font-bold text-xl tracking-tight text-[#1D3557]">
                  {pillar.title}
                </h3>
                <pillar.icon
                  size={24}
                  weight="duotone"
                  className="text-[#E63946] flex-shrink-0 ml-3"
                />
              </div>
              <p className="font-body text-sm text-[#1D3557]/55 leading-relaxed">
                {pillar.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
